/**
 * 배포 후 옛 화면 파일(chunk) 로딩 실패 → 1회 자동 새로고침.
 *
 * 배포하면 화면 파일 이름(해시)이 바뀌어, 그 전에 받은 index.html 을 쓰는 탭은 없는 파일을 요청한다.
 * 그러면 lazy 화면이 "화면을 표시하는 중 문제가 발생했습니다"(ErrorBoundary)로 끝나므로, Vite 가 알려 주는
 * 로딩 실패(vite:preloadError)에서 새로고침해 최신 index.html 을 받는다. 새로고침 직후에도 실패하면
 * (진짜 장애) 무한 새로고침 대신 오류 화면을 그대로 둔다.
 */

/** 직전 자동 새로고침 후 이 시간 안의 실패는 새로고침하지 않음(무한 루프 방지). */
export const RELOAD_GUARD_MS = 10_000;

const LAST_RELOAD_KEY = "eqms:preload-reload-at";

/** 직전 자동 새로고침 시각(없거나 손상되면 기록 없음으로 봄)과 현재 시각으로 새로고침 여부 판단. */
export function shouldReloadAfterPreloadError(lastReloadAt: number | null, now: number): boolean {
  if (lastReloadAt === null || !Number.isFinite(lastReloadAt)) return true;
  return now - lastReloadAt >= RELOAD_GUARD_MS;
}

/** 앱 시작 시 1회 호출 — 화면 파일 로딩 실패 시 새로고침 처리기 등록. */
export function installPreloadReload(): void {
  window.addEventListener("vite:preloadError", () => {
    let last: number | null = null;
    try {
      const raw = window.sessionStorage.getItem(LAST_RELOAD_KEY);
      last = raw ? Number(raw) : null;
    } catch {
      /* 스토리지 접근 불가 — 기록 없이 진행 */
    }
    // eslint-disable-next-line no-restricted-syntax -- 기록 시각 아님: 새로고침 반복 방지용 탭 내부 비교값
    const now = Date.now();
    if (!shouldReloadAfterPreloadError(last, now)) return;
    try {
      window.sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
    } catch {
      /* 기록 실패 시에도 1회 새로고침은 진행 */
    }
    window.location.reload();
  });
}
